import MainHeader from './MainHeader.vue'
export default MainHeader
